// Autogenerated
// -------------
// gulpfile.js --> generateBuildInfo

export const Build = {
    version: "6.22.18 (7c3bac92b25189169b3468bfd12782519212d508)",
    wasmSize: 2167445,
    jsSize:  503772,
};
